import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "initials",
})
export class InitialsPipe implements PipeTransform {
    transform(value: string, max = 2): string {
        if (!value) {
            return "";
        }

        return value
            .trim()
            .split(/\s+/)
            .map((w) => w[0].toUpperCase())
            .slice(0, max)
            .join("");
    }
}
